import { storage } from '@doxyme/ui/utils';
import { useLegacyUserIdContext } from '../../context/legacyUserIdContext';
import { StorageKeys } from '../../shared/constants';

/**
 * Returns the current legacy user id.
 *
 * Prefers the value from {@link LegacyUserIdContext} (authenticated tree). When
 * no provider is mounted — e.g. patient routes that must not load Frontegg
 * (PROD-7582) — it falls back to local storage. Returns an empty string when
 * the storage key is missing.
 */
export const useGetUserId = (): string => {
  const contextUserId = useLegacyUserIdContext();

  if (contextUserId !== null) {
    return contextUserId;
  }

  const storedUserId = storage.findItem(StorageKeys.CurrentUserId);
  return storedUserId === undefined ? '' : `${storedUserId}`;
};
